import React, { useEffect, useState, } from "react";
import { Create, Default, } from "components/Views";
import { Loading, } from "components";
import { axios, } from "libs";
import { useParams, useNavigate, } from "react-router-dom";
import { Validation, } from "interfaces/responses";
import {
  Button, Checkbox, Grid, TextInput,
} from "@mantine/core";
import { useUser, useAlert, useSettings, } from "hooks";
import { DeviceType, } from "interfaces/main";
import JSONForm from "components/Inputs/JsonForm";
import { resolveTheme, } from "themes/main";

function CreateDeviceType() {
  const { organization_id, } = useParams();
  const [formState, setFormState] = useState<Partial<DeviceType>>();
  const [loading, setLoading] = useState(false);
  const [validationRules, setValidationRules] = useState<Validation>();
  const [requiredFields, setRequiredFields] = useState<string[]>([]);
  const [validated, setValidated] = useState(false);
  const { hasRole, } = useUser();
  const { setAlert, } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/organizations/${organization_id}/device-types/create`)
      .then((res) => {
        const validation = res.data.data.validation as Validation;
        setValidationRules(validation);
        setRequiredFields(
          Object.entries(validation.rules)
            .filter(([, value]) => value.includes("required"))
            .map(([key]) => key)
        );
      })
      .catch((err) => {
        console.error(err);
        setAlert({
          type: "danger",
          message: "Error loading device validation rules",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    organization_id
  ]);

  const submitDeviceType = () => {
    setLoading(true);
    axios
      .post(`/organizations/${organization_id}/device-types`, formState)
      .then((res) => {
        setAlert({
          type: "success",
          message: "Device created successfully",
        });
        const newDevice = res.data.data as DeviceType;
        setLoading(false);
        navigate(
          `/organizations/${organization_id}/device-types/${newDevice.id}`
        );
      })
      .catch((err) => {
        console.error(err);
        setAlert({
          type: "danger",
          message: "Error creating device",
        });
        setLoading(false);
      });
  };

  const setPeripherals = (peripherals: DeviceType["peripherals"]) => {
    setFormState({ ...formState, peripherals, });
  };

  const {
    theme: { current, },
  } = useSettings();
  const currentTheme = resolveTheme(current);
  const { colors, } = currentTheme;

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <Create
        title="Create Device Type"
        buttons={
          [
            // {
            //   text: "Submit",
            //   handleClick: () => {
            //     submitDeviceType();
            //   },
            //   variant: "filled",
            //   color: "digitalPurple",
            //   disabled: !validated
            // }
          ]
        }
        formState={formState}
        requiredFields={requiredFields}
        setValidated={setValidated}
      >
        <Grid>
          <Grid.Col sm={12} md={6}>
            <TextInput
              label="Name"
              name="name"
              placeholder="Enter a name..."
              required={validationRules?.rules?.make?.includes("required")}
              onChange={(e) => {
                setFormState({ ...formState, name: e.currentTarget.value, });
              }}
            />
          </Grid.Col>
          {hasRole("hyperuser") && (
            <Grid.Col sm={12} md={12}>
              <Checkbox
                label="Available Globally"
                name="global"
                onChange={(e) => {
                  setFormState({
                    ...formState,
                    global: e.currentTarget.checked ? 1 : 0,
                  });
                }}
                required={validationRules?.rules?.global?.includes("required")}
              />
            </Grid.Col>
          )}
        </Grid>
      </Create>
      <Default>
        <JSONForm
          title="Peripherals"
          setFields={setPeripherals}
          fields={formState?.peripherals || {}}
        />

        <hr />
        <div
          style={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button
            color={colors.primary}
            onClick={submitDeviceType}
            disabled={!validated}
          >
            Submit
          </Button>
        </div>
      </Default>
    </div>
  );
}

export default CreateDeviceType;
